/**
 * Do not edit directly.
 * Generated via Design Token Pipeline
 */
import React from 'react';
import { convertIconPropsToSvgProps } from '../../utils';
export const IconChangeAuthenticationThin = React.forwardRef((iconProps, ref) => {
    const props = convertIconPropsToSvgProps({
        ...iconProps,
        'aria-label': 'icon-change-authentication-thin',
    });
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ref: ref, ...props },
        React.createElement("g", null,
            React.createElement("path", { d: "M11.226 2.247a.93.93 0 0 0-1.316.054L5 7.647l4.89 5.679a.93.93 0 0 0 1.314.096.936.936 0 0 0 .096-1.318L8.232 8.54h5.779c1.36 0 2.231.665 2.814 1.561.6.924.863 2.064.912 2.828v7.136c0 .516.417.934.932.934a.933.933 0 0 0 .931-.934v-7.192l-.002-.027c-.058-1.001-.386-2.493-1.213-3.765-.85-1.31-2.257-2.41-4.374-2.41H8.429l2.851-3.104a.936.936 0 0 0-.053-1.32Z" }),
            React.createElement("path", { d: "M11.226 2.247a.93.93 0 0 0-1.316.054L5 7.647l4.89 5.679a.93.93 0 0 0 1.314.096.936.936 0 0 0 .096-1.318L8.232 8.54h5.779c1.36 0 2.231.665 2.814 1.561.6.924.863 2.064.912 2.828v7.136c0 .516.417.934.932.934a.933.933 0 0 0 .931-.934v-7.192l-.002-.027c-.058-1.001-.386-2.493-1.213-3.765-.85-1.31-2.257-2.41-4.374-2.41H8.429l2.851-3.104a.936.936 0 0 0-.053-1.32Z" })),
        React.createElement("defs", null,
            React.createElement("clipPath", null,
                React.createElement("path", { d: "M0 0h24v24H0z" })))));
});
IconChangeAuthenticationThin.displayName = 'IconChangeAuthenticationThin';
export default IconChangeAuthenticationThin;
